export const formatLimit = (limit) => (
  limit === '' ? null : parseInt(limit, 10)
)
